/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/components/ui/table.tsx
 * Wrappers leves para <table/> usados nas páginas novas.
 * ========================================================================== */
import * as React from "react";

const wrap = (Tag: any, base = "") =>
    React.forwardRef<any, React.HTMLAttributes<any>>(({ className = "", ...p }, ref) => (
        <Tag ref={ref} className={`${base} ${className}`} {...p} />
    ));

export const Table = wrap("table", "w-full border-collapse text-sm");
export const TableHeader = wrap("thead", "bg-[#0f172a] text-slate-200");
export const TableBody = wrap("tbody");
export const TableRow = wrap("tr", "border-b border-slate-800");
export const TableHead = wrap("th", "text-left font-semibold px-3 py-2");
export const TableCell = wrap("td", "px-3 py-2");
export const TableFooter = wrap("tfoot", "bg-[#0f172a]");

export default Table;
